class Collapse {
  constructor(selector, options) {
    this.selector = selector;
    this.elements = document.querySelectorAll(selector);
    this.params = {
      firstOpen: false,
      ...options,
    };
    this.#init();
  }
  #init() {
    this.#event();
  }
  #event() {
    const _this = this;
    const open = target => {
      target.classList.add('active');
    };
    const close = target => {
      target.classList.remove('active');
    };
    const triggerCollapse = e => {
      const target = e.target.closest('[collapse-header]');
      const collapse = target.parentNode.querySelector('[collapse-content]');
      if (target) {
        if (target.classList.contains('active')) {
          close(target, collapse);
        } else {
          open(target, collapse);
        }
      }
    };
    _this.elements.forEach(element => {
      const collapseHeader = element.querySelectorAll('[collapse-header]');
      const collapseContent = element.querySelectorAll('[collapse-content]');
      element.addEventListener('click', triggerCollapse);
      if (_this.params.firstOpen) {
        collapseHeader[0].classList.add('active');
      }
      collapseContent.forEach(element => {
        _this.#setContentH(element);
      });
    });
  }
  #setContentH(collapse) {
    const contentH = collapse.firstChild.clientHeight;
    collapse.style.setProperty('--height', `${contentH}px`);
  }
  update() {
    const _this = this;
    _this.elements.forEach(element => {
      const collapseHeader = element.querySelectorAll('[collapse-header]');
      const collapseContent = element.querySelectorAll('[collapse-content]');
      if (_this.params.firstOpen) {
        collapseHeader[0].classList.add('active');
      }
      collapseContent.forEach(element => {
        _this.#setContentH(element);
      });
      collapseContent.forEach(element => {
        _this.#setContentH(element);
      });
    });
  }
}

export default Collapse;
